<template>
  <li class="nav-item pt-3" id="sidenav-profile">
    <a href="javascript:void(0)" class="nav-link pt-3 pb-3 mb-3" data-toggle="collapse" aria-expanded="false">
      <div class="media align-items-center justify-content-left">
        <div style="position:relative;">
          <img v-bind:src="$store.state.host.avatar || require('../../../../assets/jumpstart/img/kljukica_zelena.svg')" class="avatar rounded-circle mr-2" alt="">
          <span class="status status-right online"></span>
        </div>
        <div class="media-body title">
          <span class="media-heading bold user-name text-truncate text-capitalize">{{ $store.state.host.name.first }} {{ $store.state.host.name.last }}</span>
          <div class="small user-info text-truncate capitalize-first text-muted">{{ $store.state.host.email }}</div>
        </div>
      </div>
    </a>
    <profile-dropdown></profile-dropdown>
  </li>
</template>

<script>

  import ProfileDropdown from './ProfileDropdown.vue';

  export default {
    name: 'ProfileLink',
    components: {
      ProfileDropdown
    }
  }
</script>
